module.exports = __webpack_public_path__ + "static/img/photo-ocean-02.a1d6114.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo-ocean-02.jpg
// module id = 99YL
// module chunks = 1